import * as React from 'react';
import { HiddenInput } from "soprasteria-ui-library";
import { IReferral } from '../../../models/IReferral';
import { CareProviderSection } from "./CareProviderSection";
import { IPatient } from '../../../models/IPatient';
import { ReferralPatientInformation } from "./ReferralPatientInformation";
import { ReferralReferrerInformation } from "./ReferralReferrerInformation"
import { ReferralInformation } from "./ReferralInformation"
import { ListingCareProviderInformation } from "./ListingCareProviderInformation"
import { ReferralOtherInformation } from "./ReferralOtherInformation"
import { ReferralTreatmentReporting } from './ReferralTreatmentReporting/ReferralTreatmentReporting';
import { ReferralStatus } from './ReferralStatus';
import { isInRole, UserContext } from '../../../contexts/UserContext';
import { LIBRETTOADMIN } from '../../../utils/RoleConstants';
import { ReferralCompletionInformation } from './ReferralCompletionInformation';

interface ICreateReferralFormInputs {
    referral?: IReferral;
    isFetchingReferral: boolean;
    patient: IPatient;
    getReferral: (referralId: number) => void;
    gotReportedTreatments?: (val: boolean) => void;
}

export const CreateReferralFormInputs: React.FunctionComponent<ICreateReferralFormInputs> = ({ referral, isFetchingReferral, patient, getReferral, gotReportedTreatments }) => {

    const userInfo = React.useContext(UserContext);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles ? userInfo.roles : []);

    const setDefaultValue = (value?: string): string => {
        if (!referral?.isEditable) {
            return value ?? "Saknas";
        }
        return value ?? "";
    }

    return (
        <>
            {
                referral?.referralId ?
                    <HiddenInput name="referralId" value={referral?.referralId?.toString() ?? "-1"} />
                    : null
            }
            {
                referral?.referenceReferralId ?
                    <HiddenInput name="referenceReferralId" value={referral.referenceReferralId.toString() ?? "-1"} />
                    : null
            }
            {
                referral?.referralTypeId ?
                    <HiddenInput name="referralTypeId" value={referral.referralTypeId.toString()} />
                    : null
            }
            <HiddenInput name="patientId" value={patient.patientId.toString()} />
            <ReferralStatus referral={referral} />
            <ReferralCompletionInformation referralReasonForRequestedCompletion={referral?.reasonsForRequestedCompletion} />
            <ReferralPatientInformation patient={patient} phoneNumber={referral?.patientPhoneNumber} email={referral?.patientEmail} isEditable={referral?.isEditable} />
            {
                referral?.listingCareProvider ?
                    <>
                        <hr />
                        <ListingCareProviderInformation listingCareProvider={referral.listingCareProvider} />
                    </>
                    : null
            }
            <hr />
            <ReferralReferrerInformation referral={referral} setDefaultValue={setDefaultValue} />
            <hr />
            <CareProviderSection referral={referral} />
            <hr />
            <ReferralInformation referral={referral} />
            <hr />
            <ReferralOtherInformation referral={referral} setDefaultValue={setDefaultValue} isFetchingReferral={isFetchingReferral} />
            {
                (referral?.canReportTreatments || referral?.canAssessTreatments || hasRoleSystemAdmin || referral?.isAllowedToReadReportedTreatments) && referral?.referralId ?
                    <>
                        <hr />
                        <ReferralTreatmentReporting referral={referral} getReferral={getReferral} gotReportedTreatments={gotReportedTreatments} />
                    </>
                    : null
            }
        </>
    )
}
